import { MAX_FILE_SIZE_BYTES } from "../constants/limits";
import {
  getFileExtension,
  isAllowedExtension,
  isAllowedMimeForExtension,
} from "../constants/mime-map";
import type { StorageErrorCode } from "../types/project-storage.types";
import { getStorageErrorMessage } from "./storageErrors";

export type ValidateFileSuccess = {
  ok: true;
  warning?: string;
};

export type ValidateFileFailure = {
  ok: false;
  errorCode: StorageErrorCode;
  message: string;
};

export type ValidateFileResult = ValidateFileSuccess | ValidateFileFailure;

export type ValidateFileSelectionResult = { ok: true; files: File[] };

export function validateFileClient(file: File): ValidateFileResult {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return {
      ok: false,
      errorCode: "FILE_TOO_LARGE",
      message: getStorageErrorMessage("FILE_TOO_LARGE"),
    };
  }

  const extension = getFileExtension(file.name);
  if (!extension || !isAllowedExtension(extension)) {
    return {
      ok: false,
      errorCode: "INVALID_EXTENSION",
      message: getStorageErrorMessage("INVALID_EXTENSION"),
    };
  }

  const mimeType = file.type || "application/octet-stream";
  if (!isAllowedMimeForExtension(extension, mimeType)) {
    return {
      ok: false,
      errorCode: "INVALID_MIME",
      message: getStorageErrorMessage("INVALID_MIME"),
    };
  }

  const warning =
    mimeType === "application/octet-stream"
      ? "Tipo MIME não identificado; o envio usará application/octet-stream."
      : undefined;

  return { ok: true, warning };
}

export function validateFileSelection(files: File[]): ValidateFileSelectionResult {
  return { ok: true, files };
}

export function resolveUploadMimeType(file: File): string {
  return file.type || "application/octet-stream";
}
